export const PAYMENT_FREQUENCIES = [
  { key: "ANNUAL", name: "Annual", count: 1, months: 12 },
  { key: "QUARTERLY", name: "Quarterly", count: 4, months: 3 },
  { key: "MONTHLY", name: "Monthly", count: 12, months: 1 },
];

export const DEFAULT_ACTIVE_STATUSES = new Set([
  "DRAFT",
  "QUOTE_REQUESTED",
  "QUOTED",
  "BOUND",
]);
